const carouselItems = [
  {
    title: '91免费在线视频 · 本周必看精选',
    desc: '编辑团队精选本周最热门91免费在线视频，涵盖多元频道，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20warm%20atmosphere%20with%20elegant%20red%20and%20gold%20lighting%2C%20soft%20glowing%20textures%2C%20abstract%20theater%20feel%2C%20luxurious%20velvet%20vibe%2C%20artistic%20composition%2C%20no%20people&width=1000&height=600&seq=carousel-01&orientation=landscape',
    tag: '热门',
    color: 'from-primary-600/80 to-primary-900/80',
  },
  {
    title: '91福利在线视频 · 品质内容合集',
    desc: '91福利在线视频频道精选，从海量内容中优选品质佳作，不一样的观看体验。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20scene%20with%20amber%20and%20crimson%20gradients%2C%20soft%20light%20beams%2C%20cinematic%20elegant%20mood%2C%20sophisticated%20entertainment%20atmosphere%2C%20no%20people&width=1000&height=600&seq=carousel-02&orientation=landscape',
    tag: '精选',
    color: 'from-accent-600/80 to-accent-900/80',
  },
  {
    title: '免费视频在线观看 · 每日推荐',
    desc: '每天更新的免费视频在线观看推荐，保持新鲜感，让你每次都有新发现。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20dark%20cinematic%20background%20with%20soft%20red%20and%20gold%20gradient%20lighting%2C%20abstract%20elegant%20shapes%2C%20theater%20atmosphere%2C%20artistic%2C%20no%20text%2C%20no%20people&width=1000&height=600&seq=carousel-03&orientation=landscape',
    tag: '日更',
    color: 'from-secondary-600/80 to-secondary-900/80',
  },
  {
    title: '免费高清视频在线 · 画质盛宴',
    desc: '追求极致画质体验？免费高清视频在线为你呈现最清晰的视觉享受。',
    img: 'https://readdy.ai/api/search-image?query=Rich%20dark%20elegant%20abstract%20art%20with%20velvet%20textures%20and%20warm%20glowing%20highlights%2C%20cinematic%20atmosphere%2C%20red%20and%20gold%20tones%2C%20no%20people&width=1000&height=600&seq=carousel-04&orientation=landscape',
    tag: '高清',
    color: 'from-primary-700/80 to-accent-900/80',
  },
  {
    title: '91在线观看视频网站 · 频道导航',
    desc: '快速了解91在线观看视频网站所有频道分类，高效找到感兴趣的内容专题。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20golden%20and%20crimson%20lighting%2C%20soft%20dramatic%20atmosphere%2C%20elegant%20composition%2C%20theater%20vibe%2C%20no%20people&width=1000&height=600&seq=carousel-05&orientation=landscape',
    tag: '导航',
    color: 'from-accent-700/80 to-primary-900/80',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">91麻豆免费视频网站核心内容专题，精彩不容错过</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group relative block rounded-xl overflow-hidden aspect-[3/4] bg-background-300 cursor-pointer"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${item.color}`}></div>
              <div className="absolute top-3 left-3">
                <span className="text-xs font-medium bg-white/20 backdrop-blur-sm text-white px-2.5 py-0.5 rounded-full">{item.tag}</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-sm font-semibold text-white mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-white/75 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}